import { API } from "../../../utils";

export const getTenantSocialSettingsApi = async () => {
  const res = await API.get("/settings/social");
  return res.data;
};

export const updateTenantSocialSettingsApi = async (payload) => {
  const res = await API.put("/settings/social", payload);
  return res.data;
};
